/**
 * Vendor bundle — pinned legacy UI stack from npm dependencies (same load order as former vendor/).
 */
require('bootstrap/dist/css/bootstrap.css');
require('angular-dialog-service/dialogs.min.css');

require('jquery/dist/jquery.js');
require('es5-shim/es5-shim.js');
require('json3/lib/json3.js');
require('bootstrap/dist/js/bootstrap.js');
require('angular/angular.js');
require('angular-resource/angular-resource.js');
require('angular-cookies/angular-cookies.js');
require('jquery-ui/jquery-ui.js');
require('angular-sanitize/angular-sanitize.js');
require('angular-animate/angular-animate.js');
require('angular-touch/angular-touch.js');
require('angular-route/angular-route.js');
require('angular-messages/angular-messages.js');
require('angular-ui-bootstrap/ui-bootstrap-tpls.js');
require('angular-ui-router/release/angular-ui-router.js');
require('angular-base64/angular-base64.js');
require('ng-idle/angular-idle.js');
require('angular-ui-utils/ui-utils.js');
require('angular-translate/dist/angular-translate.js');
require('angular-translate/dist/angular-translate-loader-static-files/angular-translate-loader-static-files.js');
require('angular-dialog-service/dialogs.min.js');
require('angular-ui-date/src/date.js');
require('checklist-model/checklist-model.js');
require('ng-csv/build/ng-csv.min.js');
require('angular-validation/dist/angular-validation.js');
require('re-tree/re-tree.js');
require('ng-device-detector/ng-device-detector.js');
require('ngstorage/ngStorage.js');
